import $ from "jquery";
import {ChangeEvent, useContext, useEffect, useState} from "react";
import "../../styles/css/admin-style.css"
import { Modal, Button, Form, Dropdown } from "react-bootstrap";

interface KeywordDropdownSearchFormProps {
    searchKeywords: string[];
    DropdownOptions: string[]
    activeDropdown: string;
    onSearch: () => void;
    setSearchKeywords: (keywords: string[]) => void;
    setActiveDropdown: (option: string) => void;
}
const KeywordDropdownSearchForm: React.FC<KeywordDropdownSearchFormProps> = ({searchKeywords, DropdownOptions, onSearch, setSearchKeywords, activeDropdown, setActiveDropdown}) => {
    const [inputValue, setInputValue] = useState(searchKeywords.join(' '));

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);
        const keywordsArray = value.split(' ').map(keyword => keyword.trim()).filter(Boolean);
        setSearchKeywords(keywordsArray);
    };

    const handleDropdownSelect = (eventKey: string | null) => {
        if (eventKey !== null) {
            setActiveDropdown(eventKey);
        }
    };

    const handleSearchClick = () => {
        onSearch();
    };

    const handleClearClick = () => {
        setInputValue('');
        setActiveDropdown(DropdownOptions[0]);
        setSearchKeywords([]);
    };
    return (
        <div className="row align-items-end gx-2 mb-4">
            <div className="col mb-3 mb-xl-0">
                <label className="form-label">Keywords</label>
                <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Keywords"
                    value={inputValue}
                    onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearchClick();
                    }
                }}
                    onChange={handleInputChange}
                />
            </div>
            <div className="col-xl-2 col-lg-6 mb-3 mb-xl-0">
                <Form.Group className="w-100">
                    <Form.Label>Status</Form.Label>
                    <Dropdown onSelect={handleDropdownSelect} className="w-100">
                        <Dropdown.Toggle
                            id="dropdownMenuButton1"
                            className="btn btn-white btn-lg dropdown-toggle w-100"
                        >
                            <span>{activeDropdown}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="w-100"
                            style={{
                                position: 'absolute',
                                inset: '0px auto auto 0px',
                                margin: '0px',
                                transform: 'translate(0px, 50px)',
                            }}
                            data-popper-placement="bottom-start"
                        >
                            {DropdownOptions.map((option, index) => (
                                <Dropdown.Item key={index} eventKey={option} className={`${option === activeDropdown ? 'active' : ''} dropdown-item`}>
                                    {option}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Form.Group>
            </div>
            <div className="col-xl-auto mb-3 mb-xl-0">
                <div className="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                    <div className="col-md-auto mb-3 mb-md-0">
                        <button
                            type="button"
                            className="btn btn-primary btn-lg text-strong px-5 m-100"
                            onClick={handleSearchClick}
                        >
                            <i className="far fa-search"></i> search
                        </button>
                    </div>
                    <div className="col-md-auto">
                        <button
                            type="button"
                            className="btn btn-outline-dark btn-lg text-strong m-100"
                            onClick={handleClearClick}
                        >
                            <i className="far fa-times"></i> clear
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KeywordDropdownSearchForm;
